<div class="media-upload">
    <div class="image-upload">
        @if ((this.base64string != '')) {
            <div>
                <img [src]="this.base64string" [alt]="this.Name" [width]="this.Width" [height]="this.Height" [style.background-color]="'#' + Color" [style.padding]="'10px'" />
            </div>
        }
        <div class="container">
            <div class="button-wrap">
                <label class="button" [class.is-disabled]="this.IsLoading" [attr.for]="this.IsLoading ? null : UploadInputId">
                    @if (this.IsLoading) {
                        <span class="icon">
                            <i class="fa fa-spinner fa-spin"></i>
                        </span>
                    }
                    <span>{{ this.base64string != '' ? 'Replace Image' : 'Upload Image' }}</span>
                </label>
                <input [id]="UploadInputId" type="file" class="file-upload" (change)="UploadImage($event, ImageCategory)" [accept]="this.Type" [disabled]="this.IsLoading">
            </div>
            @if (this.Name != '') {
                <span class="media-file-name">{{this.Name}}</span>
            }
        </div>
    </div>
</div>
